import React, { Component } from "react";
import PropTypes from "prop-types";
import styles from "./MultiToggleWidget.module.scss";
import { withTranslation } from "react-i18next";

class MultiToggleWidget extends Component {
  getToggleStyles = () => {
    const { fromDealerTable } = this.props;

    return {
      switchStyle: fromDealerTable
        ? styles.switchToggleSmall
        : styles.switchToggle,
      toggleLabelStyle: fromDealerTable
        ? styles.toggleLabelSmall
        : styles.toggleLabel,
      toggleInputStyle: fromDealerTable
        ? styles.toggleInputSmall
        : styles.toggleInput,
    };
  };

  getToggleTextAndStyles = (toggleLabelStyle) => {
    const { currentStatus, settings } = this.props;

    if (currentStatus === "yes") {
      return {
        acceptedText: settings.acceptedText,
        rejectedText: "",
        acceptedStyle: `${toggleLabelStyle} ${settings.toggleLabel}`,
        rejectedStyle: styles.switchLabel,
      };
    }

    if (currentStatus === "no") {
      return {
        acceptedText: "",
        rejectedText: settings.rejectedText,
        acceptedStyle: styles.switchLabel,
        rejectedStyle: `${toggleLabelStyle} ${settings.toggleLabel}`,
      };
    }

    return {
      acceptedText: "",
      rejectedText: "",
      acceptedStyle: styles.switchLabel,
      rejectedStyle: styles.switchLabel,
    };
  };

  renderDisabledToggle = (acceptedText, rejectedText) => {
    const { settings, toggleName } = this.props;

    return (
      <div
        className={`${styles.toggleLabel} ${settings.suppClass}`}
        id={`disabled_${toggleName}`}
        data-testid={`disabled_${toggleName}`}
      >
        <div className={styles.labelYes}>{acceptedText}</div>
        <div className={styles.labelNo}>{rejectedText}</div>
      </div>
    );
  };

  renderActiveToggle = ({
    acceptedText,
    rejectedText,
    acceptedStyle,
    rejectedStyle,
    switchStyle,
    toggleInputStyle,
  }) => {
    const { currentStatus, isToggleDisabled, onSelect, settings, toggleName } =
      this.props;

    return (
      <div
        className={`${settings.suppClass} ${switchStyle} switch-2 switch-candy`}
      >
        <input
          className={toggleInputStyle}
          id={toggleName}
          data-testid={toggleName}
          disabled={isToggleDisabled}
          name={toggleName}
          type="checkbox"
          value="yes"
          onChange={onSelect}
          checked={currentStatus === "yes"}
        />
        <label htmlFor={toggleName}>
          <div className={`${acceptedStyle} ${styles.labelYes}`}>
            {acceptedText}
          </div>
          <div className={`${rejectedStyle} ${styles.labelNo}`}>
            {rejectedText}
          </div>
        </label>
      </div>
    );
  };

  render() {
    const { isToggleDisabled } = this.props;
    const { switchStyle, toggleLabelStyle, toggleInputStyle } =
      this.getToggleStyles();

    const { acceptedText, rejectedText, acceptedStyle, rejectedStyle } =
      this.getToggleTextAndStyles(toggleLabelStyle);

    if (isToggleDisabled) {
      return this.renderDisabledToggle(acceptedText, rejectedText);
    }

    return this.renderActiveToggle({
      acceptedText,
      rejectedText,
      acceptedStyle,
      rejectedStyle,
      switchStyle,
      toggleInputStyle,
    });
  }
}

MultiToggleWidget.propTypes = {
  currentStatus: PropTypes.oneOf(["yes", "no"]),
  fromDealerTable: PropTypes.bool,
  isToggleDisabled: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
  settings: PropTypes.shape({
    acceptedText: PropTypes.string,
    rejectedText: PropTypes.string,
    suppClass: PropTypes.string,
    toggleLabel: PropTypes.string,
  }).isRequired,
  toggleName: PropTypes.string.isRequired,
};

MultiToggleWidget.defaultProps = {
  currentStatus: "",
  fromDealerTable: false,
  isToggleDisabled: false,
};

export default withTranslation("emp")(MultiToggleWidget);
